<template>
  <div class="container">
    <HeadingOne class="-margin-md">口座のご登録</HeadingOne>

    <WizardGroup class="-margin-md">
      <MainWizard :active-index="2" type="entry"></MainWizard>
    </WizardGroup>

    <section>
      <NoticeBox class="-success -margin-md">
        <NoticeHeader>
          <h2 class="heading">
            口座のご登録ならびにご本人さま確認が完了しました。<br />「お申し込みを完了する」を押してください。
          </h2>
        </NoticeHeader>
      </NoticeBox>

      <BtngroupSingle class="-margin-lg">
        <BtnMain
          class="-main"
          router-name="tem006"
          onmousedown="dlpoloan_kouzatourokuClickCv()"
        >
          お申し込みを完了する
        </BtnMain>
      </BtngroupSingle>
    </section>
  </div>
</template>

<script>
import { setMeta } from "@/utils/Meta";
import HeadingOne from "@/components/heading/HeadingOne";
import WizardGroup from "@/components/wizard/WizardGroup";
import MainWizard from "@/components/wizard/MainWizard";
import NoticeBox from "@/components/box/NoticeBox";
import NoticeHeader from "@/components/box/NoticeHeader";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
export default {
  name: "Tem002",
  components: {
    BtnMain,
    BtngroupSingle,
    NoticeHeader,
    NoticeBox,
    MainWizard,
    WizardGroup,
    HeadingOne,
  },
  setup() {
    setMeta({
      title: "口座のご登録",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,入会,口座登録",
    });
  },
  data() {
    return {};
  },
  mounted() {},
};
</script>

<style scoped></style>
